/* Theme presentation only: the merchant confirmed this offer. Never writes prices,
 * selling-plan IDs, billing/delivery policies, contracts, inventory or Appstle configuration. */
(() => {
  let observer = null;
  let frame = 0;
  // Future refill wording below is the merchant's intended offer, not verified backend billing.
  // Checkout currently shows $128 every 180 days; do not publish until Appstle/checkout terms match.
  const autoHTML = "<p class=\"vf99-offer-row\"><strong>Today:</strong> Showerhead + two filters — one free</p> <p data-vf-offer-refill-timing>First refill at day 180, then $34 every 3 months.</p> <p data-vf-offer-cancel>Cancel anytime.</p>";
  const autoText = "Today: Showerhead + two filters — one free First refill at day 180, then $34 every 3 months. Cancel anytime.";
  const oneHTML = "<p class=\"vf99-offer-row\">Showerhead + 1 installed filter.</p> <p data-vf-offer-onetime-detail>One payment. No automatic refills.</p>";
  const oneText = "Showerhead + 1 installed filter. One payment. No automatic refills.";
  const text = node => (node?.textContent || '').replace(/\s+/g, ' ').trim();
  function copy(node, html, expected, marker) {
    if (!node) return;
    if (text(node) !== expected) node.innerHTML = html;
    if (!node.hasAttribute(marker)) node.setAttribute(marker, '');
  }
  function amount(node) {
    const match = node?.textContent.replace(/,/g, '').match(/\$\s*(\d+(?:\.\d{1,2})?)/);
    return match ? Math.round(Number(match[1]) * 100) : null;
  }
  function scan() {
    frame = 0;
    const wrapper = document.querySelector('.vf-premium-product .appstle_subscription_wrapper');
    if (!wrapper) return;
    const options = Array.from(wrapper.querySelectorAll('.appstle_subscription_wrapper_option'));
    const auto = options.find(option => option.querySelector('input[type="radio"][name="selling_plan"]')?.value);
    const one = options.find(option => option.querySelector('input[type="radio"][name="selling_plan"]')?.value === '');
    let title = wrapper.querySelector(':scope > .vf100-choice-title');
    if (!title) {
      title = document.createElement('p');
      title.className = 'vf100-choice-title';
      title.textContent = 'Choose your starter kit';
      wrapper.prepend(title);
    }
    if (auto) {
      const label = auto.querySelector('.appstle_subscribe_save_text');
      if (label && text(label) !== 'Starter kit + Auto-ship') label.textContent = 'Starter kit + Auto-ship';
      label?.setAttribute('data-vf100-option-label', '');
      auto.querySelectorAll('.appstleSellingPlanDescription, .appstleSelectedSellingPlanOptionDescription').forEach(node => copy(node, autoHTML, autoText, 'data-vf99-auto-description'));
      // Remove the obsolete timing caption; timing now follows Today inside the offer.
      auto.querySelectorAll('[data-vf-legal-refill-timing]').forEach(node => node.remove());
      const badge = auto.querySelector('.appstle-save-badge');
      // Anchor the existing savings badge to the card edge, not the nested price row.
      if (badge && badge.parentElement !== auto) auto.appendChild(badge);
      const autoAmount = amount(auto.querySelector('.appstle_subscription_amount'));
      const oneAmount = amount(one?.querySelector('.appstle_subscription_amount'));
      if (badge && autoAmount !== null && oneAmount !== null && oneAmount > autoAmount) {
        const saving = (oneAmount - autoAmount) / 100;
        const formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: Number.isInteger(saving) ? 0 : 2, maximumFractionDigits: 2 }).format(saving);
        const label = 'Save ' + formatted + ' today';
        if (text(badge) !== label) badge.textContent = label;
        badge.setAttribute('data-vf99-saving', '');
      }
    }
    if (one) {
      const label = one.querySelector('.appstle_one_time_text');
      if (label && text(label) !== 'One-time starter kit') label.textContent = 'One-time starter kit';
      label?.setAttribute('data-vf100-option-label', '');
      // Remove only the old, duplicated pseudo-caption—not radio decorations.
      [one, ...one.querySelectorAll('*')].forEach(node => {
        if (/1[\s\S]*VitalFlow[\s\S]*1[\s\S]*filter/i.test(getComputedStyle(node, '::after').content)) node.setAttribute('data-vf99-legacy-caption', '');
        if (/1[\s\S]*VitalFlow[\s\S]*1[\s\S]*filter/i.test(getComputedStyle(node, '::before').content)) node.setAttribute('data-vf99-legacy-before', '');
      });
      copy(one.querySelector('.appstle_one_time_description_text'), oneHTML, oneText, 'data-vf99-one-description');
    }
  }
  function queue() { if (!frame) frame = requestAnimationFrame(scan); }
  function initialize() {
    observer?.disconnect();
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    const product = document.querySelector('.vf-premium-product');
    if (!product) return;
    observer = new MutationObserver(queue);
    observer.observe(product, { childList: true, subtree: true, characterData: true });
    scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('product-info:loaded', initialize);
  window.addEventListener('pageshow', initialize);
})();
